import { registerSettingsCard } from '../../components/SettingsCards';
import type { ModuleRoute } from '../types';
import { PreRegistrationsPage } from './PreRegistrationsPage';
import { MembersSettingsCard, PreRegistrationSettingsCard } from './SettingsCards';

registerSettingsCard('pre-registration', PreRegistrationSettingsCard);
registerSettingsCard('members', MembersSettingsCard);

/** Pages of this area (pre-registrations, expected-visit and onboarding email editors, pre-arrival site info). Owned by Phase 2 task W11; only that task edits files in this folder. */
export const routes: ModuleRoute[] = [{ path: '/pre-registrations', element: <PreRegistrationsPage />, permission: 'today.view' }];
